(ns dre.pages.dictionary.term-sind
  (:require
   [clojure.string :as str]
   [dre.pages.dictionary.util :as util]))

;; https://docs.drugbank.com/json/#structured-indications
;; https://dev.drugbank.com/guides/indications/structure

(defn kind-item
  [kind row]
  (let [condition (->> row
                       ((juxt :condition :induction_of
                              :therapy :process :mechanism))
                       (map :title)
                       (remove nil?)
                       (str/join ", "))
        fmt (fn [title] [:<> title " " [:strong condition]])]
    [:span
     (case (keyword kind)
       :treatment_of [fmt "Treatment of"]
       :prevention_of [fmt "Prevention of"]
       :prophylaxis_of [fmt "Prophylaxis of"]
       :symptomatic_treatment_of [fmt "Symptomatic treatment of"]
       :management_of [fmt "Management of"]
       :for_therapy [fmt "For"]
       :induction_of [fmt "Induction of"]
       :reversal_of [fmt "Reversal of"]
       :diagnostic_agent [fmt "Diagnostic agent"]
       :diagnostic_process [fmt "Diagnostic process"]

       :adjunct_therapy_in_prevention_of [fmt "Adjunct therapy in prevention of"]
       :adjunct_therapy_in_prophylaxis_of [fmt "Adjunct therapy in prophylaxis of"]
       :adjunct_therapy_in_treatment_of [fmt "Adjunct therapy in treatment of"]
       :adjunct_therapy_in_management_of [fmt "Adjunct therapy in management of"]
       :adjunct_for_therapy [fmt "Adjunct for"]

       :used_in_combination_to_treat [fmt "In combination to treat"]
       :used_in_combination_for_symptomatic_treatment_of [fmt "In combination for symptomatic treatment of"]
       :used_in_combination_for_therapy [fmt "In combination for"]
       :used_in_combination_to_induce [fmt "In combination to induce"]
       :used_in_combination_to_manage [fmt "In combination to manage"]
       :used_in_combination_to_prevent [fmt "In combination to prevent"]
       :used_in_combination_for_prophylaxis_of [fmt "In combination for prophylaxis of"]
       :used_in_combination_as_diagnostic_agent [fmt "In combination as diagnostic agent"]
       :used_in_combination_for_diagnostic_process [fmt "In combination diagnostic process"]
       :used_in_combination_to_reverse [fmt "In combination to reverse"]

       :used_as_adjunct_in_combination_to_treat [fmt "As adjunct in combination to treat"]
       :used_as_adjunct_in_combination_for_symptomatic_treatment_of [fmt "As adjunct in combination for symptomatic treatment of"]
       :used_as_adjunct_in_combination_for_therapy [fmt "As adjunct in combination for"]
       :used_as_adjunct_in_combination_to_prevent [fmt "As adjunct in combination to prevent"]
       :used_as_adjunct_in_combination_to_manage [fmt "As adjunct in combination to manage"]
       "?")]))

(def indications-map
  (array-map
   :kind ["Kind" kind-item]
    ;:equivalent_concept ["Equivalent" util/object-item]
   :condition_associated_with ["Condition associated with" util/list-item]
   :combination_drugs ["Combination drugs" util/list-item]
   :combination_drug_categories ["Combination drug categories" util/list-item]
    ;:combination_type ["Combination type" util/str-item]
   :adjunct_drugs ["Adjunct drugs" util/array-item]
   :adjunct_drug_categories ["Adjunct drug categories" util/list-item]
   :with_therapies ["With therapies" util/list-item]
    ;:product_concepts ["Products" util/list-item]
    ;:with_product_concepts ["With products" util/list-item]
   :patient_characteristics ["Patient characteristics" util/list-item]
   :excluded_patient_characteristic ["Excluded patient characteristics" util/list-item]
   :route ["Route" util/array-item]
   :dose_form ["Dose form" util/array-item]
   :dose_strength ["Dose strength" util/str-item]
   :timeline ["Timeline" util/str-item]
   :regions ["Regions" util/array-item]
   :sex_group ["Sex group" util/str-item]
   :min_age ["Min age" util/age-item]
   :max_age ["Max age" util/age-item]
   :age_groups ["Age groups" util/array-item]
   :excluded_age_groups ["Excluded age groups" util/array-item]
   :off_label ["Off label" util/bool-item]
   :otc_use ["OTC use" util/bool-item]))